export class GetMenuPosition {
    static readonly type = 'GetMenuPosition';
    constructor() { }
}

export class SetMenuPosition {
    static readonly type = 'SetMenuTop';
    constructor(public position: string) { }
}

export class SetMenuPositionSuccess {
    static readonly type = 'SetMenuTopSuccess';
    constructor(public payload: any) { }
}

export class LogoutUser {
    static readonly type = 'LogoutUser';
    constructor() { }
}

export class LogoutUserSuccess {
    static readonly type = 'LogoutUserSuccess';
    constructor(public payload: any) { }
}
